// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name, other,w=22,h=22) => (
  other ?
    <img alt="navIcon" src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.${other}`} style={{ width: w, height: h }} />
    :
    <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const Masters = [
  {
    title: 'Company',
    path: '/dashboard/masters/ref/company',
    icon: icon('company','png'),
    ShortName: 'Masters_Company',
  }, {
    title: 'Buyer',
    path: '/dashboard/masters/ref/buyer',
    icon: icon('buyer22'),
    ShortName: 'Masters_Buyer',
  },{
    title: 'User',
    path: '/dashboard/masters/ref/user',
    icon: icon('user'),
    ShortName: 'Masters_User',
  },
  {
    title: 'Division',
    path: '/dashboard/masters/ref/division',
    icon: icon('division','png',32,32),
    ShortName: 'Masters_Division',
  }, {
    title: 'Color',
    path: '/dashboard/masters/ref/color',
    icon: icon('color','png'),
    ShortName: 'Masters_Color',
  }, {
    title: 'Garment',
    path: '/dashboard/masters/ref/garment',
    icon: icon('garment','png'),
    ShortName: 'Masters_Garment',
  },{
    title: 'Fabric Type',
    path: '/dashboard/masters/ref/fabricType',
    icon: icon('fabricType'),
    ShortName: 'Masters_Fabric_type',
  },{
    title: 'Composition',
    path: '/dashboard/masters/ref/composition',
    icon: icon('composition'),
    ShortName: 'Masters_Composition',
  },{
    title: 'Fabric',
    path: '/dashboard/masters/ref/fabric',
    icon: icon('fabric'),
    ShortName: 'Masters_Fabric',
  },{
    title: 'Designation',
    path: '/dashboard/masters/ref/designation',
    icon: icon('designation'),
    ShortName: 'Masters_Designation',
  },{
    title: 'Department',
    path: '/dashboard/masters/ref/Department',
    icon: icon('department'),
    ShortName: 'Masters_Department',
  },{
    title: 'Trims Category',
    path: '/dashboard/masters/ref/TrimsCategory',
    icon: icon('trimsCategory'),
    ShortName: 'Masters_Trims_Category',
  },{
    title: 'Trims',
    path: '/dashboard/masters/ref/Trims',
    icon: icon('trims'),
    ShortName: 'Masters_Trims',
  },{
    title: 'General',
    path: '/dashboard/masters/ref/general',
    icon: icon('general','png'),
    ShortName: 'Masters_General',
  },
  {
    title: 'UOM',
    path: '/dashboard/masters/ref/uom',
    icon: icon('uom','png'),
    ShortName: 'Masters_UOM',
  },
  {
    title: 'UOMconvertor',
    path: '/dashboard/masters/ref/uomconvertor',
    icon: icon('uomconvertor','png'),
    ShortName: 'Masters_Convertor',
  },
  {
    title: 'Country',
    path: '/dashboard/masters/ref/country',
    icon: icon('country','png'),
    ShortName: 'Masters_Country',
  },
  {
    title: 'Season',
    path: '/dashboard/masters/ref/season',
    icon: icon('session','png'),
    ShortName: 'Masters_Season',
  },
  {
    title: 'Track',
    path: '/dashboard/masters/ref/track',
    icon: icon('track'),
    ShortName: 'Masters_Track',
  },
  {
    title: 'Size',
    path: '/dashboard/masters/ref/size',
    icon: icon('size'),
    ShortName: 'Masters_Size',
  },
  {
    title: 'Color Template',
    path: '/dashboard/masters/ref/ColorTemplate',
    icon: icon('colorTemplate'),
    ShortName: 'Masters_Color_Template',
  }
];

export default Masters;
